import { View, Text, StyleSheet } from 'react-native';
import { Colors } from '@/constants/colors';

interface Props {
  title: string;
  count?: number;
  accent?: string;
}

export function SectionHeader({ title, count, accent }: Props) {
  return (
    <View style={styles.container}>
      {accent && <View style={[styles.accent, { backgroundColor: accent }]} />}
      <Text style={styles.title}>{title}</Text>
      {count !== undefined && (
        <View style={styles.badge}>
          <Text style={styles.count}>{count}</Text>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingTop: 20,
    paddingBottom: 8,
    gap: 8,
  },
  accent: {
    width: 3,
    height: 14,
    borderRadius: 2,
  },
  title: {
    color: Colors.textSecondary,
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 1,
    textTransform: 'uppercase',
    flex: 1,
  },
  badge: {
    backgroundColor: Colors.surface,
    borderRadius: 10,
    paddingHorizontal: 7,
    paddingVertical: 2,
  },
  count: {
    color: Colors.textSecondary,
    fontSize: 10,
    fontWeight: '600',
  },
});
